import { Box, Grid, Collapse, Card } from "@mui/material";

import ActiveFilters from "../../../../Components/filters/ActiveFilters";

import FilterItems from "./FilterItems";

const Filter = ({
  roles,
  filterOpen,
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  handleRemove,
  submittedData,
}) => {
  // All filters in the order they appear
  const activeFilterDefinitions = [
    // Standard filters - in order
    // {
    //   type: "standard",
    //   id: "employeeName",
    //   label: "Employee Name",
    //   value: submittedData.employeeName,
    // },
    {
      type: "standard",
      id: "userName",
      label: "Username",
      value: submittedData.userName,
    },
    {
      type: "standard",
      id: "active",
      label: "Active",
      value: submittedData.active,
    },
    {
      type: "standard",
      id: "role",
      label: "Role",
      value:
        roles?.find((r) => r.id === submittedData?.role)?.name ||
        submittedData?.role,
    },
  ];

  return (
    <>
      <Grid item xs={12}>
        <Collapse in={filterOpen}>
          <Card>
            <Box p={4}>
              <FilterItems
                roles={roles}
                filterData={filterData}
                handleChangeFilter={handleChangeFilter}
                handleFilter={handleFilter}
                handleClearFilters={handleClearFilters}
              />
            </Box>
          </Card>
        </Collapse>
      </Grid>

      <ActiveFilters
        filterDefinitions={activeFilterDefinitions}
        onRemoveFilter={handleRemove}
      />
    </>
  );
};

export default Filter;
